import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Layout } from '@/components/layout/Layout'
import { AuthGuard } from '@/components/AuthGuard'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import { LoginPage } from '@/pages/LoginPage'
import { UsersPage } from '@/pages/UsersPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { ChatViewerPage } from '@/pages/ChatViewerPage'
import { ThreadsPage } from '@/pages/ThreadsPage'
import { AIInsightsPage } from '@/pages/AIInsightsPage'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <AuthGuard>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/ai-insights" replace />} />
                      <Route path="/ai-insights" element={<AIInsightsPage />} />
                      <Route path="/users" element={<UsersPage />} />
                      <Route path="/users/:userId" element={<UserDetailPage />} />
                      <Route path="/users/:userId/chats" element={<ChatViewerPage />} />
                      <Route path="/threads" element={<ThreadsPage />} />
                    </Routes>
                  </Layout>
                </AuthGuard>
              }
            />
          </Routes>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
